import React from "react";
import { ErrorAndMaintenance } from "../views/errorAndMaintenance";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Error caught in ErrorBoundary:", error, errorInfo);
  }

  render() {
    return this.state.hasError ? (
      <ErrorAndMaintenance labelTitle="Something went wrong. Please try again later." />
    ) : (
      this.props.children
    );
  }
}
